import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'element-ui/lib/theme-chalk/index.css'
import './css/common.less'
import './css/main.less'
import Vue from 'vue'
import { getCookie } from 'tool'

Vue.prototype.$ELEMENT = { size: 'small', zIndex: 6000 }

// stylesheet

// ajax
import ajax from 'communicate/ajax/index.js'
Vue.prototype.$ajax = ajax

// jsonp
import jsonp from 'communicate/jsonp/index.js'
Vue.prototype.$jsonp = jsonp

// vue-router
import VueRouter from 'vue-router'
import routes from 'router/index'
Vue.use(VueRouter)
const router = new VueRouter({
	routes
})

// vuex
import store from 'store/index.js'
import App from './App.vue'

// app
new Vue({
	router,
	store,
	render: h => h(App),
	data: {
		alivePageList: [], // 缓存页面列表
		access_token: getCookie('access_token') || '', // jm token
		clientWidth: ''
	},
	watch: {},
	created() {},
	beforeMount() {
		// this.clientWidth = document.documentElement.clientWidth;
		// document.documentElement.style.fontSize = 100 * (this.clientWidth / 1920) + 'px';
		// this.setPro = this.clientWidth / 1920;
	},
	mounted() {
		// window.onresize = ()=> {
		//     this.clientWidth = document.documentElement.clientWidth;
		//     document.documentElement.style.fontSize = 100 * (this.clientWidth / 1920) + 'px';
		// };
	},
	methods: {
		addPageAlive(name) {
			if (!name) {
				return
			}
			this.checkAliveExist(name) === null && this.alivePageList.push(name)
		},
		removePageAlive(name) {
			if (!name) {
				return
			}

			const index = this.checkAliveExist(name)

			typeof index === 'number' && this.alivePageList.splice(index, 1)
		},
		checkAliveExist(name) {
			const index = this.alivePageList.indexOf(name)
			return index === -1 ? null : index
		}
	}
}).$mount('#app')
